// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"de02c681","48":"14b99dd7","89":"b956ccb7","520":"8ddefdf2","597":"2dcafbf3","649":"879fae76","667":"1507eab5","723":"42c32a72","798":"b094436d","954":"735eff02"}[chunkId] + ".chunk.js";
};